import { render, staticRenderFns } from "./SuperannuationAppraisals.vue?vue&type=template&id=d8c55dec&scoped=true&"
import script from "./SuperannuationAppraisals.vue?vue&type=script&lang=ts&"
export * from "./SuperannuationAppraisals.vue?vue&type=script&lang=ts&"
import style0 from "./SuperannuationAppraisals.vue?vue&type=style&index=0&id=d8c55dec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c55dec",
  null
  
)

export default component.exports